const devicesBulkEditActionList = [
  { name: 'Activate as POS', value: 'activate-pos' },
  { name: 'Activate as Game', value: 'activate-game' },
  { name: 'Deactivate', value: 'deactivate' },
  { name: 'Block', value: 'block' },
  { name: 'Assign to Site', value: 'assign-site' },
  // { name: 'Apply Tag', value: 'apply-tag' },
  // { name: 'Remove Tag', value: 'remove-tag' },

]

export default devicesBulkEditActionList